(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcs-studio-global"]) return;
  try {
    
  (() => {
    const normalize = (value) => {
      let path = value || '/';
      if (path.length > 1 && path.endsWith('/')) path = path.slice(0, -1);
      return path;
    };
    const paint = (link) => {
      const label = link.querySelector('.header__active-menu-item') || link;
      if (label.dataset.mcsColored === 'true') return;
      const words = label.textContent.trim().split(/\s+/).filter(Boolean);
      if (words.length < 2) return;
      label.textContent = '';
      words.forEach((word, index) => {
        if (index) label.appendChild(document.createTextNode(' '));
        const span = document.createElement('span');
        span.className = index === 0 ? 'mcs-nav-red' : index === words.length - 1 ? 'mcs-nav-blue' : 'mcs-nav-white';
        span.textContent = word;
        label.appendChild(span);
      });
      label.dataset.mcsColored = 'true';
      link.classList.add('mcs-nav-active');
    };
    const colorActiveLinks = () => {
      const current = normalize(window.location.pathname);
      document.querySelectorAll('.header__inline-menu a.header__menu-item, .menu-drawer a.menu-drawer__menu-item').forEach((link) => {
        const path = normalize(new URL(link.href, window.location.origin).pathname);
        if (link.getAttribute('aria-current') === 'page' || path === current) paint(link);
      });
    };
    const setQuantity = (root = document) => {
      root.querySelectorAll('input[name="quantity"]').forEach((input) => {
        const value = Number.parseInt(input.value, 10);
        if (!value || value < 1) {
          input.value = '1';
          input.setAttribute('value', '1');
        }
      });
    };
    const init = () => {
      colorActiveLinks();
      setQuantity();
      new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            colorActiveLinks();
            setQuantity(node);
          }
        }));
      }).observe(document.body, { childList:true, subtree:true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  (() => {
    const alignChase = () => {
      document.querySelectorAll('[data-mcs-chase-scene][data-mcs-placement="desktop"]').forEach((lane) => {
        const row = lane.closest('.header');
        if (!row) return;
        const links = [...row.querySelectorAll('.header__inline-menu > .list-menu > li > .header__menu-item')].filter((link) => link.offsetParent !== null);
        const first = links.find((link) => /coin|patch/i.test(link.textContent)) || links[0];
        const last = links.find((link) => /contact/i.test(link.textContent)) || links.at(-1);
        if (!first || !last) return;
        const rowBox = row.getBoundingClientRect();
        const firstBox = first.getBoundingClientRect();
        const lastBox = last.getBoundingClientRect();
        lane.style.left = `${Math.max(0,firstBox.left-rowBox.left)}px`;
        lane.style.width = `${Math.max(320,lastBox.right-firstBox.left)}px`;
      });
      document.querySelectorAll('[data-mcs-chase-scene]').forEach((lane) => {
        lane.style.setProperty('--mcs-travel',`${lane.clientWidth+8}px`);
      });
    };
    const scheduleSmoke = (lane) => {
      const truck = lane.querySelector('.mcs-chase-truck');
      const particles = [...lane.querySelectorAll('.mcs-chase-smoke')];
      const emissionTimes = [1050,1350,1650,1950,2250,2550,2850];
      if (!truck || !particles.length) return;
      (lane.mcsSmokeTimers || []).forEach((timer) => window.clearTimeout(timer));
      lane.mcsSmokeTimers = [];
      particles.forEach((particle,index) => {
        particle.classList.remove('is-smoking');
        const timer = window.setTimeout(() => {
          const laneBox = lane.getBoundingClientRect();
          const truckBox = truck.getBoundingClientRect();
          const rearTireX = truckBox.left + truckBox.width * .29 - laneBox.left;
          if (rearTireX < 0 || rearTireX > laneBox.width) return;
          particle.style.left = `${rearTireX}px`;
          particle.classList.remove('is-smoking');
          void particle.offsetWidth;
          particle.classList.add('is-smoking');
        },emissionTimes[index]);
        lane.mcsSmokeTimers.push(timer);
      });
    };
    const replayChase = () => {
      document.querySelectorAll('[data-mcs-chase-scene]').forEach((lane) => {
        (lane.mcsSmokeTimers || []).forEach((timer) => window.clearTimeout(timer));
        lane.querySelectorAll('.mcs-chase-smoke').forEach((particle) => particle.classList.remove('is-smoking'));
        lane.classList.remove('is-replaying');
        void lane.offsetWidth;
        lane.classList.add('is-replaying');
        scheduleSmoke(lane);
      });
    };
    const initHeaderEffects = () => {
      alignChase();
      replayChase();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initHeaderEffects,{once:true});
    else initHeaderEffects();
    window.addEventListener('resize',() => {
      alignChase();
    });
    window.addEventListener('pageshow',(event) => {
      if (event.persisted) replayChase();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
